import { UPDATE_SEARCHTDATA_TAIKHOANICLOUD } from "../../actions/QuanTriHeThong/actionTypes";

const initialState = {
  SoDienThoai: "",
  TenTaiKhoan: "",
  SoHDLienKet: -1,
  iHanChe: -1,
  iLock: -1,
  iPageIndex: 1,
  iPageSize: 25,
};

const updateDataSearchTaiKhoanIcloud = (state, action) => ({
  ...action.payload,
});

export const dataSearchTaiKhoanIcloudReducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case UPDATE_SEARCHTDATA_TAIKHOANICLOUD:
      return updateDataSearchTaiKhoanIcloud(state, action);
    default:
      return state;
  }
};

export default dataSearchTaiKhoanIcloudReducer;
